import { useMemo } from "react";
import { Box, Typography } from "@mui/material";

const Profile = ({ userProfile, profileError }) => {

  const renderProfile = useMemo(() => {
    if (profileError) {
      return (
        <Typography variant="body2" color="error" sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
          {profileError}
        </Typography>
      );
    }
    if (!userProfile) {
      return (
        <Typography variant="body2" sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
          Please log in.
        </Typography>
      );
    }

    return (
      <>
        <Typography variant="subtitle2" sx={{ fontSize: { xs: "14px", sm: "16px" }, fontWeight: "bold" }}>
          Welcome, {userProfile.displayName}!
        </Typography>
        <Typography variant="body2" sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
          {userProfile.mail || userProfile?.userPrincipalName}
        </Typography>
      </>
    );
  }, [userProfile, profileError]);

  // JSX render
  return (
    <Box
      sx={{
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        p: { xs: 1, sm: 2 }, // Responsive padding
        width: "100%", // Ensure full width on all devices
      }}
    >
      {renderProfile}
    </Box>
  );
};

export default Profile;